// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"e287768e","453":"7c195a21","884":"541ecf83"}[chunkId] + ".chunk.js";
};